import React, { useEffect } from 'react'
import './modal-prehome.scss'
import hoverImage from '../../../assets/images/prehome/hoverimage.png'
import icondown from '../../../assets/images/prehome/icondown.svg'
import trazoHeader from '../../../assets/images/prehome/trazo_header.svg'
import image1 from '../../../assets/images/prehome/image1.png'
import image2 from '../../../assets/images/prehome/image2.png'
import image3 from '../../../assets/images/prehome/image3.png'
import image4 from '../../../assets/images/prehome/image4.png'
import trazo1 from '../../../assets/images/prehome/trazo1.svg'
import trazo2 from '../../../assets/images/prehome/trazo2.svg'
import trazo3 from '../../../assets/images/prehome/trazo3.svg'
import card1 from '../../../assets/images/prehome/card1.png'
import card2 from '../../../assets/images/prehome/card2.png'
import card3 from '../../../assets/images/prehome/card3.png'
import mainLogo from '../../../assets/images/prehome/logo_grupo_bancolombia.svg'
import logo1 from '../../../assets/images/prehome/bancolombia.svg'
import logo2 from '../../../assets/images/prehome/banistmo.svg'
import logo3 from '../../../assets/images/prehome/bancoagricola.svg'
import logo4 from '../../../assets/images/prehome/bam.svg'
import logo5 from '../../../assets/images/prehome/Grupobancolombia.png'
import closeIcon from '../../../assets/images/prehome/close.svg'
import { graphql, useStaticQuery } from 'gatsby';
import downIcon from '../../../assets/images/prehome/down.svg'
import OptionsRedirect from '../../molecules/options-redirect/options-redirect'

const ModalPrehome = props => {
    
    const { contentfulEnlacesPreHomeFooter, allContentfulRedSocial, contentfulEnlacesPreHomeBody} = useStaticQuery( graphql`
    {
        contentfulEnlacesPreHomeFooter {
            enlacesFooter {
              enlace
              titulo
              id
            }
          }
          allContentfulRedSocial {
            nodes {
              slug
              iconoFooter {
                file {
                  url
                }
              }
              nombre
            }
          }
          contentfulEnlacesPreHomeBody {
            enlace {
              enlace
            }
          }
      }
    `);
    const { enlacesFooter } = contentfulEnlacesPreHomeFooter;
    const { nodes: enlacesRedSocial } = allContentfulRedSocial;
    const { enlace: enlacePrehomeBody } = contentfulEnlacesPreHomeBody;
    
    const { closePrehome } = props

    useEffect(() => {
        main()
    }, [])

    const main = () => {
        let isMobile = window.innerWidth < 1024

        if (!isMobile) {
            handleShowHideImageBannerHover()
        }

        initButtonScrollClick()
        initScrollListener()
        /*initSelectClick()*/
    }   

    const handleScrollModal = e => {
        let scrollModalValue = e.target.scrollTop
        let listSections = [...document.getElementsByClassName('modal-prehome-fenix-section')]
        let listPositionSections = listSections.map(e => e.offsetTop)
        let listTextContainers = listSections.map(e => e.getElementsByClassName('modal-prehome-fenix-section-text-container')).filter(e => e.length !== 0)
        let listImagesContainers = listSections.map(e => e.getElementsByClassName('modal-prehome-fenix-section-image-container')).filter(e => e.length !== 0)
        let listStrokes = listImagesContainers.map(e => e[0].getElementsByClassName('modal-prehome-fenix-svg')).filter(e => e.length !== 0)
        let sectionCenteredText = document.getElementsByClassName('modal-prehome-fenix-section-centered-text-container')[0]
        let isMobile = window.innerWidth < 1024
        let translateValue = isMobile ? 'translateX(' : 'translateY('

        listTextContainers.forEach((e, index) => {
            e[0].style.opacity = (100000 / ((listPositionSections[index] - (scrollModalValue)) ** 2))

            if (!isMobile) {
                e[0].style.transform = translateValue +
                    ((listPositionSections[index] - (scrollModalValue)) / 4)
                    + 'px)'
            }
        });

        listImagesContainers.forEach((e, index) => {

            if (index === 2 && (listPositionSections[index] - (scrollModalValue)) < -200) {
                e[0].style.opacity = (50000 / ((listPositionSections[index] - (scrollModalValue)) ** 2))

            } else {

                e[0].style.opacity = (100000 / ((listPositionSections[index] - (scrollModalValue)) ** 2))
            }

            e[0].style.transform = translateValue +
                (((listPositionSections[index] * -2) + ((scrollModalValue) * 2)) / 4)
                + 'px)'
        });

        listStrokes.forEach((e, index) => {
            e[0].style.transform = translateValue +
                ((listPositionSections[index] - (scrollModalValue)) / 2)
                + 'px)'
        });

        if (!isMobile) {

            /*sectionCenteredText.style.opacity = (100000 / ((listPositionSections[4] - (scrollModalValue)) ** 2))
            sectionCenteredText.style.transform = translateValue +
                ((listPositionSections[4] - (scrollModalValue)) / 5)
                + 'px)'*/
        }
    }

    const initButtonScrollClick = () => {
        let button = document.getElementById('button-scroll');
        button.addEventListener('click', handleClickScroll)
    }

    const initScrollListener = () => {
        let modal = document.getElementById('modal-prehome-fenix')
        modal.addEventListener('scroll', handleScrollModal)
    }

    let handleClickScroll = () => {
        let section = document.getElementById('section-second')
        section.scrollIntoView()
    }

    const handleShowHideImageBannerHover = () => {
        let hoverElement = document.getElementById('modal-main-hover');
        let boxImageContainer = document.getElementById('box-image-move-container')
        let revelatorCircle = document.getElementById('modal-hover-white-revelator')
        // let fisrtFilterImage = document.getElementById('modal-hover-move-box-filter-image')
        // let secondFilterImage = document.getElementById('modal-hover-move-box-filter-text')

        hoverElement.addEventListener('mouseenter', () => {
            boxImageContainer.classList.add('showing')
            revelatorCircle.classList.add('showing')
            hoverElement.addEventListener('mousemove', handleMouseMove)
        }, false);
        hoverElement.addEventListener('mouseout', () => {
            boxImageContainer.classList.remove('showing')
            revelatorCircle.classList.remove('showing')
            hoverElement.removeEventListener('mousemove', handleMouseMove)
        }, false);
    }

    const handleMouseMove = (event) => {
        let boxImageContainer = document.getElementById('box-image-move-container')
        let revelatorCircle = document.getElementById('modal-hover-white-revelator')
        let textRevelator = document.getElementById('text-revelator')

        boxImageContainer.style.left = (event.offsetX) + 'px'
        boxImageContainer.style.top = (event.offsetY) + 'px'

        revelatorCircle.style.left = (event.offsetX) + 'px'
        revelatorCircle.style.top = (event.offsetY) + 'px'

        textRevelator.style.left = (event.offsetX * -1) + 'px'
        textRevelator.style.top = (event.offsetY * -1) + 'px'

    }   

    return (
        <div className="modal-prehome-fenix" id='modal-prehome-fenix'>
            <div className="modal-prehome-fenix-header">
                <div className="modal-prehome-fenix-header-info">
                    <div className="modal-prehome-fenix-header-info-close" onClick={() => closePrehome()}>
                        <img
                            alt='Ícono de cerrar'
                            src={closeIcon}
                        />
                    </div>
                    <div className="modal-prehome-fenix-header-info-buttons">
                        <div className="modal-prehome-fenix-container-options">
                            <OptionsRedirect />
                        </div>
                        <a className="modal-prehome-fenix-header-info-button-home" href={'#'} onClick={() => closePrehome()}>
                            IR A LA PÁGINA PRINCIPAL
                        </a>
                    </div>
                </div>
            </div>
            <section className="modal-prehome-fenix-main-banner">
                <div className="modal-prehome-fenix-main-banner-rotater rotating" id='rotate-element'>
                    <img
                        alt='Trazo rotador'
                        src={trazoHeader}
                    />
                </div>
                <div className="modal-prehome-fenix-main-banner-title">
                    <div className="modal-hover-move-box" id="box-image-move-container" >
                        <img
                            src={hoverImage}
                            alt='Imagen destacada banner'
                            className="modal-hover-move-box-image"
                        />
                    </div>
                    <h1 id='modal-main-hover'>Bienvenido a tu nueva Bamvirtual Personas</h1>
                    <div className="modal-hover-white-revelator" id='modal-hover-white-revelator'>
                        <h2 id="text-revelator">Bienvenido a tu nueva Bamvirtual Personas</h2>
                    </div>
                </div>                
                <p>En Bam evolucionamos para estar más cerca de ti y nos retamos día a día, ya que estamos comprometidos en brindarte un mejor servicio.</p>
                <div className="modal-prehome-fenix-button-scroll" id='button-scroll'>
                    <div id="scroll-label" className="modal-prehome-fenix-button-scroll-label"></div>
                    <img
                        className="modal-prehome-fenix-button-scroll-icon"
                        alt='Ícono de botón de scroll'
                        src={icondown}
                    />
                </div>
            </section>
            {/*<section className="modal-prehome-fenix-section background-white" id='section-first'>
                <div className="modal-prehome-fenix-section-info">
                    <div className="modal-prehome-fenix-section-text-container">
                        <h2>Desde el Grupo Bancolombia creemos que la evolución se trata de hacer las cosas por las personas, entender sus necesidades, ponerse en sus zapatos y escucharlos. </h2>
                    </div>
                    <div className="modal-prehome-fenix-section-image-container centered">
                        <img
                            alt='Primera imagen'
                            src={image1}
                        />
                        <img
                            alt='Primer trazo'
                            src={trazo1}
                            className='modal-prehome-fenix-svg first'
                        />
                    </div>
                </div>
            </section>
            <section className="modal-prehome-fenix-section background-gray">
                <div className="modal-prehome-fenix-section-info mobile-reverse">
                    <div className="modal-prehome-fenix-section-image-container centered">
                        <img
                            alt='Segunda imagen'
                            src={image2}
                        />
                        <img
                            alt='Segundo trazo'
                            src={trazo2}
                            className='modal-prehome-fenix-svg'
                        />

                    </div>
                    <div className="modal-prehome-fenix-section-text-container">
                        <div className="modal-prehome-fenix-section-text-wrapper">
                            <h2>Solo así aprenderemos a reconocer las diferencias, buscando valores compartidos, mediante respeto, empatía, cercanía y transparencia.</h2>
                        </div>
                    </div>
                </div>
            </section>
            <section className="modal-prehome-fenix-section background-white">
                <div className="modal-prehome-fenix-section-info">
                    <div className="modal-prehome-fenix-section-text-container">
                        <h2>Sabemos que evolucionar requiere valentía, somos conscientes que no es algo que se logra de la noche a la mañana, pero queremos hacerlo y estamos comprometidos a mejorar todos los días.</h2>
                    </div>
                    <div className="modal-prehome-fenix-section-image-container centered">
                        <img
                            alt='Tercera imagen'
                            src={image3}
                        />
                        <img
                            alt='Tercer trazo'
                            src={trazo3}
                            className='modal-prehome-fenix-svg'
                        />
                    </div>
                </div>
                <p className="p-centered-in-section">Evolucionar requiere valentía, somos conscientes que no es algo de un día, pero queremos hacerlo y estamos comprometidos a mejorar todos los días. Porque nuestra gran diversidad es nuestra fuerza colectiva.</p> 
            </section>
            <section className="modal-prehome-fenix-section background-green">
                <div className="modal-prehome-fenix-section-info">
                    <div className="modal-prehome-fenix-section-image-container centered image-in-top-mobile">
                        <img
                            alt='Cuarta imagen'
                            src={image4}
                        />
                        <img
                            alt='Segundo trazo'
                            src={trazo2}
                            className='modal-prehome-fenix-svg'
                        />
                    </div>
                    <div className="modal-prehome-fenix-section-text-container">
                        <div className="modal-prehome-fenix-section-text-wrapper">
                            <h2>Por eso creemos que la evolución se trata de mejorar, de aprender, de continuar.</h2>
                            <br></br>
                            <p>
                                Se trata de acercarnos más, de ser más útiles, de acompañar.
                                <br></br>
                                <br></br>
                        Se trata de apoyar más, de compartir más conocimiento, de que las cosas buenas sean para todos, de aprovechar nuestra gran diversidad y convertirlo en nuestra fuerza colectiva.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="modal-prehome-fenix-section background-white">
                <div className="modal-prehome-fenix-section-centered-text-container">
                    <div className="modal-prehome-fenix-section-centered-text ">
                        <h2 className="custom-h h2">
                            Se trata de retarnos todos los días, de mejorar como personas y juntos, dar bienestar a nuestra sociedad, desde lo que hacemos. De eso se trata. Y eso, es lo que nos mueve.
                        </h2>
                        <p>
                            En otras palabras, se trata de estar
                        </p> 
                    </div>
                    <h2 className="modal-prehome-fenix-big-text">Contigo de corazón.</h2>
                </div>
            </section>*/}
            <section className="modal-prehome-fenix-section background-white" id="section-second">
                <div className="modal-prehome-fenix-section-card-container">                    
                    <div className="modal-prehome-fenix-section-card-container-list">
                        <div className="modal-prehome-fenix-section-card">
                            <img
                                alt='Imagen de tarjeta'
                                src={card1}
                            />
                            <h3>¿Necesitas ayuda con las nuevas funciones?</h3>
                            <p className="modal-prehome-fenix-section-card-info">Visita nuestros videos tutoriales.</p>
                            <a className="modal-prehome-fenix-card-redirect" href={enlacePrehomeBody[0].enlace} rel='noopener noreferrer' target='_blank'>
                                CONOCE MÁS
                            </a>
                        </div>
                        <div className="modal-prehome-fenix-section-card">
                            <img className='modal-prehome-fenix-section-card-img'
                                alt='Imagen de tarjeta'
                                src={card2}
                            />
                            <h3>Descarga nuestra nueva Bamapp Personas</h3>
                            <p>Escanea el código QR y disfruta de las nuevas funcionalidades de nuestra Bamapp.</p>
                            <a className="modal-prehome-fenix-card-redirect" href='https://www.bam.com.gt/bamapp-personas/' rel='noopener noreferrer' target='_blank'>
                                CONOCE MÁS
                            </a>
                        </div>
                        <div className="modal-prehome-fenix-section-card">
                            <img 
                                alt='Imagen de tarjeta'
                                src={card3}
                            />
                            <h3>¿Quieres saber más?</h3>
                            <p>Visita nuestra página de preguntas frecuentes y entérate de todas las novedades que hemos desarrollado especialmente para ti.</p>
                            <a className="modal-prehome-fenix-card-redirect" href='https://www.bam.com.gt/preguntas-frecuentes/' rel='noopener noreferrer' target='_blank'>
                                CONOCE MÁS
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section className="modal-prehome-fenix-section background-black">             
                <div className="modal-prehome-fenix-section-bank-mini-logo">
                    { 
                        enlacesFooter.map((item) => (
                            <div key={item.id} className="modal-prehome-fenix-section-bank-mini-logo-link">
                                <a href={item.enlace} target='_blank' rel='noopener noreferrer'>
                                   {item.titulo}
                                </a>
                            </div>
                        ))
                    }                   
                </div>
                <div className="modal-prehome-fenix-section-bank-logos">
                    <div className="modal-prehome-fenix-section-bank-logos-bam">
                        <a href='#' rel='noopener noreferrer' onClick={ e => e.preventDefault}>
                            <img
                                className="modal-prehome-fenix-section-bank-logos-bam-img"
                                alt='Logo principal bancolombia'
                                src={logo4}
                            />                           
                        </a>
                    </div>
                    <div className="modal-prehome-fenix-section-bank-redes">
                      <div className="modal-prehome-fenix-section-bank-redes-container">
                      {
                          enlacesRedSocial.map((item, index) => {
                            return (
                                <a                                   
                                    key={index}
                                    href={item.slug}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <img
                                        src={item.iconoFooter.file.url}
                                        alt={'icono de red social ' + item.nombre}
                                        title={item.nombre}                                        
                                    />
                                </a>
                            )
                        })
                      }
                      </div>
                      <div className="modal-prehome-fenix-section-bank-redes-separator-container">
                        <hr className="modal-prehome-fenix-section-bank-redes-separator"/>
                      </div>                      
                    </div>   
                    <div className="modal-prehome-fenix-section-bank-logos-cr">
                       <span>Copyright ©  2021 Grupo Bancolombia </span>
                    </div>                  
                    <div className="modal-prehome-fenix-section-bank-logos-grupobc">
                        <a href='#' rel='noopener noreferrer' onClick={ e => e.preventDefault}>
                            <img
                                alt='Logo principal Grupo bancolombia'
                                src={logo5}
                            />                           
                        </a>
                    </div>                    
                </div>
            </section>

        </div>
    )
}

export default ModalPrehome
